module.exports = __webpack_public_path__ + "img/album18_27.12187ea6.jpg";